import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { Lesson, Pupil, StudentExExerciseStat } from '@df/interfaces';
import { TaskService } from '@app/core/services/task.service';
import { GENDER, MAIN_DOMAIN } from '@app/app.constants';
import { Router } from '@angular/router';

import { closeIcon } from '@app/app.constants';

@Component({
    selector: 'app-pupil',
    templateUrl: './pupil.component.html',
    styleUrls: ['./pupil.component.scss']
})
export class PupilComponent implements OnInit, OnDestroy, OnChanges {
    @Input() pupil: Pupil;
    @Input() pupilId: number;
    @Input() pupilIndex: number;
    @Input() lesson: Lesson;
    @Input() isTeach: boolean;

    @Output() closePupilCard = new EventEmitter<boolean>();

    MAIN_DOMAIN = MAIN_DOMAIN;
    lessonResults = [];
    exExerciseStat: StudentExExerciseStat;
    GENDER = GENDER;
    closeIcon = closeIcon;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private taskService: TaskService, private router: Router) {}

    public ngOnInit(): void {
        if (this.lesson) {
            this.getStudentExercisesAnalytics();
        }

        this.getExExerciseStatForStudent();
    }

    ngOnChanges(): void {
        if (this.pupilId) {
            this.getStudentExercisesAnalytics();
            this.getExExerciseStatForStudent();
        }
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    public goToStudentAccount() {
        this.router.navigate(['/teacher/accounts/', this.lesson.student_class], {
            queryParams: {
                student: this.pupilIndex + 1,
                subject: this.lesson.subject,
                lesson: this.lesson.id
            }
        });
    }

    getExExerciseStatForStudent() {
        this.taskService
            .getExExerciseStatForStudent(this.lesson.id, this.pupil.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe(resp => {
                this.exExerciseStat = resp;
            });
    }

    getStudentExercisesAnalytics() {
        this.taskService
            .getStudentExercisesAnalytics(this.lesson.id, this.pupilId)
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                if (response) {
                    this.lessonResults = response.response;
                }
            });
    }

    close() {
        this.closePupilCard.emit(true);
    }
}
